/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GeotabLoginRequest,
  GeotabLoginResponse,
  IsaacLoginRequest,
  IsaacLoginResponse,
  TokenExchangeRequest,
  TokenExchangeResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Login<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name Auth0TokenexchangeCreate
   * @request POST:/login/auth0/tokenexchange
   */
  auth0TokenexchangeCreate = (data: TokenExchangeRequest, params: RequestParams = {}) =>
    this.request<TokenExchangeResponse, void>({
      path: `/login/auth0/tokenexchange`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name Auth0CallbackList
   * @request GET:/login/auth0/callback
   */
  auth0CallbackList = (
    query: {
      /** Auth0 state parameter */
      state: string;
      /** Auth0 authorization code */
      code: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/login/auth0/callback`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @name GeotabCreate
   * @request POST:/login/geotab
   */
  geotabCreate = (data: GeotabLoginRequest, params: RequestParams = {}) =>
    this.request<GeotabLoginResponse, void>({
      path: `/login/geotab`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name IsaacDirectCreate
   * @request POST:/login/isaac/direct
   */
  isaacDirectCreate = (data: IsaacLoginRequest, params: RequestParams = {}) =>
    this.request<IsaacLoginResponse, void>({
      path: `/login/isaac/direct`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name IsaacWebCreate
   * @request POST:/login/isaac/web
   */
  isaacWebCreate = (
    data: IsaacLoginRequest,
    query?: {
      /** URL to redirect to after login */
      returnTo?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/login/isaac/web`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name Auth0List
   * @request GET:/login/auth0
   */
  auth0List = (
    query?: {
      /** URL to send the user after successful login */
      returnTo?: string;
      /** Email address or phone number of unauthenticated user */
      identifier?: string;
      /** Name of social or SSO identity provider */
      connection?: string;
      /** Alternative authentication methods such as password */
      authMethod?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/login/auth0`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @name LoginList
   * @request GET:/login
   */
  loginList = (
    query?: {
      /** URL to send the user after successful login */
      returnTo?: string;
      /** alternative authentication methods such as password */
      authMethod?: string;
      email?: boolean;
      phone?: boolean;
      social?: boolean;
      /** comma separated list of valid domains for email login */
      validDomains?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, void>({
      path: `/login`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @name TokenList
   * @request GET:/login/token
   */
  tokenList = (
    query: {
      /** Login token */
      token: string;
      /** URL to redirect after successful login */
      returnTo?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/login/token`,
      method: "GET",
      query: query,
      ...params,
    });
}
